var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "caseSharing" },
    [
      _c("TopNavigation", { attrs: { TopAct: "1" } }),
      _c(
        "div",
        { class: this.$store.state.webNavigator == "pc" ? "" : "pan110" },
        [
          _c("listTopImg", { attrs: { imgType: "1" } }),
          _c(
            "div",
            {
              staticClass: "marginAuto",
              class: this.$store.state.webNavigator == "pc" ? "max1720" : ""
            },
            [
              _c("articlePage", {
                key: _vm.keys,
                attrs: {
                  listType: "A10",
                  titles: "案例分享",
                  pageIndex: _vm.current,
                  navLsit: _vm.navList,
                  active: _vm.types,
                  toLeveListPath: _vm.toLeveListPath
                },
                on: { getTotal: _vm.getTotal }
              }),
              _c("Pagination", {
                attrs: {
                  total: _vm.total,
                  display: 12,
                  "current-page": _vm.current
                },
                on: { pagechange: _vm.getPage }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("FooterNavigation")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-15fa96f8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15fa96f8","hasScoped":true,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/caseSharing/caseSharing.vue
// module id = 1172
// module chunks = 3